/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Holds all required information about the desired policy (quote).
 * @export
 * @interface CRSFSecReviewDesiredPolicyFieldsInput
 */
export interface CRSFSecReviewDesiredPolicyFieldsInput {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    agency: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    attachment_point?: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    company_name: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    company_revenue: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    created?: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    employee_count: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    industry: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    insurance_market?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    is_excess: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    mfa_email?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    mfa_other_privileged_accounts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    mfa_remote_access?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    pii_phi_count: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    quote_origination?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    technical_sophistication?: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDesiredPolicyFieldsInput
     */
    updated?: string;
}

/**
 * Check if a given object implements the CRSFSecReviewDesiredPolicyFieldsInput interface.
 */
export function instanceOfCRSFSecReviewDesiredPolicyFieldsInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "agency" in value;
    isInstance = isInstance && "company_name" in value;
    isInstance = isInstance && "company_revenue" in value;
    isInstance = isInstance && "employee_count" in value;
    isInstance = isInstance && "industry" in value;
    isInstance = isInstance && "is_excess" in value;
    isInstance = isInstance && "pii_phi_count" in value;

    return isInstance;
}

export function CRSFSecReviewDesiredPolicyFieldsInputFromJSON(json: any): CRSFSecReviewDesiredPolicyFieldsInput {
    return CRSFSecReviewDesiredPolicyFieldsInputFromJSONTyped(json, false);
}

export function CRSFSecReviewDesiredPolicyFieldsInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDesiredPolicyFieldsInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'agency': json['agency'],
        'attachment_point': !exists(json, 'attachment_point') ? undefined : json['attachment_point'],
        'company_name': json['company_name'],
        'company_revenue': json['company_revenue'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'employee_count': json['employee_count'],
        'industry': json['industry'],
        'insurance_market': !exists(json, 'insurance_market') ? undefined : json['insurance_market'],
        'is_excess': json['is_excess'],
        'mfa_email': !exists(json, 'mfa_email') ? undefined : json['mfa_email'],
        'mfa_other_privileged_accounts': !exists(json, 'mfa_other_privileged_accounts') ? undefined : json['mfa_other_privileged_accounts'],
        'mfa_remote_access': !exists(json, 'mfa_remote_access') ? undefined : json['mfa_remote_access'],
        'pii_phi_count': json['pii_phi_count'],
        'quote_origination': !exists(json, 'quote_origination') ? undefined : json['quote_origination'],
        'technical_sophistication': !exists(json, 'technical_sophistication') ? undefined : json['technical_sophistication'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
    };
}

export function CRSFSecReviewDesiredPolicyFieldsInputToJSON(value?: CRSFSecReviewDesiredPolicyFieldsInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'agency': value.agency,
        'attachment_point': value.attachment_point,
        'company_name': value.company_name,
        'company_revenue': value.company_revenue,
        'created': value.created,
        'employee_count': value.employee_count,
        'industry': value.industry,
        'insurance_market': value.insurance_market,
        'is_excess': value.is_excess,
        'mfa_email': value.mfa_email,
        'mfa_other_privileged_accounts': value.mfa_other_privileged_accounts,
        'mfa_remote_access': value.mfa_remote_access,
        'pii_phi_count': value.pii_phi_count,
        'quote_origination': value.quote_origination,
        'technical_sophistication': value.technical_sophistication,
        'updated': value.updated,
    };
}

